import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useRef, useState, useEffect } from 'react';

var useOverflowTooltip = function useOverflowTooltip() {
  var ref = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOverflowActive = _useState2[0],
    setOverflow = _useState2[1];
  var isTextOverflowing = function isTextOverflowing(refObject) {
    if (refObject !== null && refObject.current) {
      return refObject.current.offsetWidth < refObject.current.scrollWidth;
    }
    return false;
  };
  useEffect(function () {
    setOverflow(isTextOverflowing(ref));
  }, [isOverflowActive]);
  return [ref, isOverflowActive];
};

export { useOverflowTooltip };
